import React from 'react';
import Link from 'gatsby-link';
import './header.scss';
import './social-icon.scss';

import blackLogo from '../assets/images/TFP-logo-header-black.png';
import whiteLogo from '../assets/images/TFP-logo-header-white.png';

export default class Header extends React.Component {
    constructor(props) {
        super(props);
        this.state = { menuOpen: false };
        this.closeDropdown = this.closeDropdown.bind(this);
        this.toggleDropdown = this.toggleDropdown.bind(this);
    }

    closeDropdown() {
        this.setState({ menuOpen: false });
    }

    toggleDropdown() {
        this.setState({ menuOpen: !this.state.menuOpen });
    }

    render() {
        const location = this.props.location;
        const inBlogSection = location && location.pathname.indexOf('/blog') === 0;
        const inBlogArticle = inBlogSection && location.pathname.length > 5;
        const inCollaborationsSection = location && location.pathname.indexOf('/collaborations') === 0;
        const inTerms = location && location.pathname.indexOf('/terms') === 0;
        const inPrivacy = location && location.pathname.indexOf('/privacy') === 0;
        const blackHeader = inCollaborationsSection || inTerms || inPrivacy;

        return (
            <div
                className={`header
          ${blackHeader ? 'header__black' : ''}
          ${this.state.menuOpen ? 'header__mobile-menu-open' : ''}
        `}
            >
                <h3>The Farm Project</h3>
                <div className="header__links-container">
                    <Link activeClassName="active" to={'/about'}>
                        About Us
                    </Link>
                    <Link activeClassName="active" to={'/collaborations'}>
                        Collaborations
                    </Link>
                    <Link activeClassName="active" to={'/blog'}>
                        Blog
                    </Link>
                    <Link activeClassName="active" to={'/careers'}>
                        Careers
                    </Link>
                    <a href="https://www.lettucegrow.com/" target="_blank" rel="noopener noreferrer">
                        Lettuce Grow<i className="fas fa-external-link-alt" />
                    </a>
                </div>

                <div className="mobile">
                    <input id="mobile-nav" type="checkbox" checked={this.state.menuOpen ? 'checked' : ''} />
                    <label onClick={this.toggleDropdown}>
                        <b>
                            <i />
                            <i />
                            <i />
                        </b>
                    </label>

                    <menu>
                        <li>
                            <Link to={'/about'} onClick={this.toggleDropdown}>
                                About Us
                            </Link>
                        </li>
                        <li>
                            <Link to={'/collaborations'} onClick={this.toggleDropdown}>
                                Collaborations
                            </Link>
                        </li>
                        <li>
                            <Link to={'/blog'} onClick={this.toggleDropdown}>
                                Blog
                            </Link>
                        </li>
                        <li>
                            <Link to={'/careers'} onClick={this.toggleDropdown}>
                                Careers
                            </Link>
                        </li>
                        <li>
                            <a href="https://www.lettucegrow.com/" target="_blank" rel="noopener noreferrer">
                                Lettuce Grow
                                <i className="fas fa-external-link-alt" />
                            </a>
                        </li>
                        <div className="mobile-social">
                            <div>FOLLOW US</div>
                            <a className="social-icon" href="https://instagram.com/farmproject" target="_blank">
                                <span className="fab fa-instagram" />
                            </a>
                            <a className="social-icon" href="https://www.facebook.com/thefarmproject" target="_blank">
                                <span className="fab fa-facebook" />
                            </a>
                        </div>
                    </menu>
                </div>

                <Link to={inBlogArticle ? '/blog' : '/'} onClick={this.closeDropdown}>
                    <img className="header__logo header__logo__black" src={blackLogo} />
                    <img className="header__logo header__logo__white" src={whiteLogo} />
                </Link>

                <div className="header__social">
                    <a className="social-icon" href="https://instagram.com/farmproject" target="_blank">
                        <i className="fab fa-instagram" />
                    </a>
                    <a className="social-icon" href="https://www.facebook.com/thefarmproject" target="_blank">
                        <i className="fab fa-facebook" />
                    </a>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/header.js